import { newE2EPage } from "@stencil/core/testing";

describe("uic-app-header", () => {
    it("should render correctly if no slots are slots provided", async () => {
        const page = await newE2EPage();
        await page.setContent(`
            <uic-app-header></uic-app-header>`);
        const header = await page.find("uic-app-header.hydrated");
        await page.waitForChanges();
        expect(header).toMatchSnapshot();
    });

    it("should render correctly with main-menu, notifications and settings", async () => {
        const page = await newE2EPage();
        await page.setContent(`
            <uic-app-header notifications-supported="true" settings-supported="true">
                <uic-header-menu name="main-menu" slot="main-menu">
                    <uic-header-menu-item name="menu-item-1" selected="true">
                        Menu Item 1
                    </uic-header-menu-item>
                    <uic-header-menu-item name="menu-item-2">
                        Menu Item 2
                    </uic-header-menu-item>
                </uic-header-menu>
            </uic-app-header>
        `);
        const header = await page.find("uic-app-header.hydrated");
        await page.waitForChanges();
        const mainMenu = await page.find(
            "uic-header-menu[name=main-menu].hydrated"
        );
        await page.waitForChanges();
        expect(await mainMenu.getProperty("current")).toEqual("menu-item-1");
        expect(header).toMatchSnapshot();
    });

    it("should open and close related view when settings or notifications icon is clicked", async () => {
        const page = await newE2EPage();
        await page.setContent(`
            <uic-app-header></uic-app-header>
        `);
        const uicMenuChange = await page.spyOnEvent("uicMenuChange");
        const header = await page.find("uic-app-header.hydrated");

        // Connect related views
        header.setProperty("settingsView", { opened: false });
        header.setProperty("notificationsView", { opened: false });
        await page.waitForChanges();

        // click settings menu item
        const settingsMenuItem = await page.find(
            "uic-header-menu-item[name=settings].hydrated"
        );
        await settingsMenuItem.click();
        await expect(uicMenuChange).toHaveReceivedEventDetail({
            name: "dialog",
            current: "settings",
        });
        await page.waitForChanges();
        expect(await header.getProperty("settingsView")).toEqual({
            opened: true,
        });
        expect(await header.getProperty("notificationsView")).toEqual({
            opened: false,
        });

        // click notifications menu item
        const notificationsMenuItem = await page.find(
            "uic-header-menu-item[name=notifications].hydrated"
        );
        await notificationsMenuItem.click();
        await expect(uicMenuChange).toHaveReceivedEventDetail({
            name: "dialog",
            current: "notifications",
        });
        await page.waitForChanges();
        expect(await header.getProperty("settingsView")).toEqual({
            opened: false,
        });
        expect(await header.getProperty("notificationsView")).toEqual({
            opened: true,
        });
    });

    it("should render correctly with custom translations", async () => {
        const page = await newE2EPage();
        await page.setContent(`
            <uic-app-header notifications-supported="true" settings-supported="true"></uic-app-header>
        `);
        const header = await page.find("uic-app-header");
        await page.waitForChanges();
        await header.setProperty("translations", {
            closeButton: "Test Close Button",
            helpLabel: "Test Help Label",
            homeLabel: "Test Home Label",
            logoutButton: "Test Logout",
            notificationsLabel: "Test Notifications",
            noUserDataLabel: "Test No User Data",
            settingsLabel: "Test Settings",
            userLabel: "Test User Label",
            userProfileLinkText: "Test Profile Link Text",
        });
        await page.waitForChanges();
        expect(header).toMatchSnapshot();
    });
});
